// extracted by mini-css-extract-plugin
export default {"flex-column":"following_flex-column__hPGTw","main-container":"following_main-container__bWy38","flex-row":"following_flex-row__a5sms","page-size":"following_page-size__e6zKH"};